// extracted by mini-css-extract-plugin
export default {"span":"SpanStatus_span__J2rB8"};